import React, { useEffect, useState } from "react";
import report_icon from "../assets/img/report-nav-icon.png";
import report_source_icon from "../assets/img/database-nav-icon.png";
import user_icon from "../assets/img/users-nav-icon.png";
import left_arrow from "../assets/img/current-page-nav.png";
import kafein_logo from "../assets/img/kafein-logo-white.png";
import klogo from "../assets/img/klogo.png";
import logo from "../assets/img/logo192.png";
import project from "../assets/img/projects.png";
import micro_reporter_api from "../apis/micro-reporter-api";
import diamond from "../assets/img/diamond.png";
import diamond2 from "../assets/img/diamond2.png";
import dashboard from "../assets/img/dashboard.png";
import calendar from "../assets/img/calendar.jfif";
import schedule from "../assets/img/schedule.png";
import Utils from "../libraries/utils";

const SideNavigation = (props) => {
	const [projectSubMenu, setProjectSubMenu] = useState([]);
	const [projectId, setProjectId] = useState(0);
	const [reportListDisplay, setReportListDisplay] = useState(false);
	const [kLogo, setKLogo] = useState(false);
	useEffect(() => {
		// if(localStorage.getItem("sideBar")){
		// 	arrowClick(localStorage.getItem("sideBar"));
		// }
		getProjectList();
	}, []);

	const getProjectList = () => {
		(async () => {
			try {
				Utils.loadingScreen("show");
				let user = JSON.parse(localStorage.getItem("user"));
        await micro_reporter_api
					.get(`/micro-reporter/project/find-by-user-id?userId=` + user.id)
					.then((response) => {
						setProjectSubMenu(response.data);
						Utils.loadingScreen("hide");
					});
			} catch (err) {
				Utils.loadingScreen("hide");
			}
		})();
	};

	const showProjectSubMenu = () => {
		document.querySelector(".project-sub-menu-list").classList.toggle("none");
	};

	const arrowClick = (item) => {
		localStorage.setItem("sideBar", item);
		if (item == "left") {
			document.querySelector("#left-arrow").style.display = "none";
			document.querySelector("#mySidenav").style.display = "none";
			document.querySelector("#none-sidebar").style.display = "block";
			// document.querySelector('.page-order').style.marginLeft = '50px'
		} else {
			document.querySelector("#left-arrow").style.display = "block";
			document.querySelector("#mySidenav").style.display = "block";
			document.querySelector("#none-sidebar").style.display = "none";
			// document.querySelector('.page-order').style.marginLeft = '190px'
		}
	};

	const renderConnectionLink = (props) => {
		if (
			localStorage.getItem("user") !== null &&
			JSON.parse(localStorage.getItem("user"))?.role === "ADMIN"
		) {
			return (
				<a className="link" href="/connections">
					<img src={report_source_icon} alt=""></img>
					DB Connections
					{props.current === "sources" ? renderCurrentPageArrow() : null}
				</a>
			);
		}
	};

	const renderUserLink = (props) => {
		if (
			localStorage.getItem("user") !== null &&
			JSON.parse(localStorage.getItem("user"))?.role === "ADMIN"
		) {
			return (
				<a
					className="link"
					href="/users"
					onClick={() => {
						localStorage.removeItem("projectId");
					}}
				>
					<img src={user_icon} alt=""></img>
					Users
					{props.current === "users" ? renderCurrentPageArrow() : null}
				</a>
			);
		}
	};

	const renderReportLink = (props) => {
		if (localStorage.getItem("user") !== null) {
			return (
				<div>
					<div
						className="link"
						id="report-sub-title"
						onClick={(e) => showProjectSubMenu()}
					>
						<img src={report_icon} style={{ marginBottom: "3px" }} alt=""></img>
						Reports
						{props.current === "reports" ? renderCurrentPageArrow() : null}
					</div>

					<ul className="project-sub-menu-list">
						<li
							className="project-sub-menu-item"
							onClick={() => localStorage.setItem("projectId", "all-34f456")}
						>
							<a href={"/reports"}>
								{localStorage.getItem("projectId") &&
									localStorage.getItem("projectId") == "all-34f456" ? (
									<img src={diamond2} alt=""></img>
								) : (
									<img src={diamond} alt=""></img>
								)}
								All
							</a>
						</li>
					</ul>
				</div>
			);
		}
	};

	const renderProjectLink = (props) => {
		if (
			localStorage.getItem("user") !== null &&
			JSON.parse(localStorage.getItem("user"))?.role === "ADMIN"
		) {
			return (
				<a
					className="link"
					href="/projects"
					onClick={() => {
						localStorage.removeItem("projectId");
					}}
				>
					<img src={project} alt=""></img>
					Projects
					{props.current === "projects" ? renderCurrentPageArrow() : null}
				</a>
			);
		}
	};

	const renderDashboardLink = (props) => {
		return (
			<a
				className="link"
				href="/dashboard"
				onClick={() => {
					localStorage.removeItem("projectId");
				}}
			>
				<img src={dashboard} alt=""></img>
				Dashboard
				{props.current === "dashboard" ? renderCurrentPageArrow() : null}
			</a>
		);
	};

	const renderScheduleListLink = (props) => {
		return (
			<a
				className="link"
				href="/schedule"
				onClick={() => {
					localStorage.removeItem("projectId");
				}}
			>
				<img src={schedule} alt=""></img>
				Scheduled Reports
				{props.current === "schedule" ? renderCurrentPageArrow() : null}
			</a>
		);
	};

	const renderCurrentPageArrow = () => {
		return <img className="current" src={left_arrow} alt="" />;
	};

	const showSubMenu = () => {
		if (localStorage.getItem("user") !== null) {
		}
	};

	const reportItemDisplayNone = () => {
		setReportListDisplay(false);
		document.querySelector(".report-list").classList.toggle("block");
		setKLogo(false);
	};

	const reportItemDisplayBlock = () => {
		setReportListDisplay(!reportListDisplay);
		document.querySelector(".report-list").classList.add("block");
	};

	const logoDisplayBlock = () => {
		setKLogo(true);
	}

	return (
		<div>
			{/* <div id="none-sidebar">
				<a id="right-arrow" onClick={(e) => arrowClick('right')}>
         	<i className="fa fa-chevron-circle-right" aria-hidden="true"></i>
        </a>
			</div>
			
			<div id="mySidenav" className="sidenav">
         <a id="left-arrow" onClick={(e) => arrowClick('left')}>
         	<i className="fa fa-chevron-circle-left" aria-hidden="true"></i>
         </a>
				 
          <div id="brand">
            <img src={logo} alt="Micro Reporter" id="logo"/>
            <span id="logo_title">Micro Reporter</span>
          </div>
					{renderDashboardLink(props)}
          {renderReportLink(props)}
          {renderProjectLink(props)}
				{renderScheduleListLink(props)}
          {renderUserLink(props)}
		    
          <div id="kafein">
              <img
                  src={kafein_logo}
                  width="140"
                  height="35"
                  className="d-inline-block align-top"
                  alt="Kafein"
              />
          </div>
      </div> */}

			<nav
				className="main-menu"
				onMouseLeave={() => {
					reportItemDisplayNone();
				}}
				onMouseEnter={() => {
					logoDisplayBlock();
				}}
			>
				<ul className="micro-logo"> 
					<li>
						<a
							href="/dashboard"
							onClick={() => {
								localStorage.removeItem("projectId");
							}}
						>
							<img
								className="micro-report-logo"
								src={logo}
								alt="Micro Reporter"
								id="logo"
							/>
							<span className="logo-text">Micro Reporter</span>
						</a>
					</li>
				</ul>
				<ul>

					{props.current === "dashboard" ?
						<li className="has-subnav current">
							<a
								href="/dashboard"
								onClick={() => {
									localStorage.removeItem("projectId");
								}}
							>
								<i className="fa fa-home fa-2x"></i>
								<span className="nav-text">Dashboard</span>
							</a>
						</li>
						:
						<li className="has-subnav">
							<a
								href="/dashboard"
								onClick={() => {
									localStorage.removeItem("projectId");
								}}
							>
								<i className="fa fa-home fa-2x"></i>
								<span className="nav-text">Dashboard</span>
							</a>
						</li>
					}


					{props.current === "reports" ?
					<li className="has-subnav current display-report">
						<a onClick={() => { reportItemDisplayBlock(); }} >
							<i className="fa fa-file-o fa-2x"></i>
							<span className="nav-text">
								Reports
								{!reportListDisplay ? (
									<i
										className="fa fa-chevron-left close-reports-list"
										aria-hidden="true"
										style={{display: "inline-grid", fontSize: "14px"}}
									></i>
								) : (
									<i
										className="fa fa-chevron-down close-reports-list"
										aria-hidden="true"
										style={{display: "inline-grid", fontSize: "14px"}}
									></i>
								)}
							</span>
						</a>
					</li>
						:
					<li className="has-subnav display-report">
						<a onClick={() => {
							reportItemDisplayBlock();
						}}>
							<i className="fa fa-file-o fa-2x"></i>
							<span className="nav-text">
							Reports
								{!reportListDisplay ? (
									<i
										className="fa fa-chevron-left close-reports-list"
										aria-hidden="true"
										style={{display: "inline-grid", fontSize: "14px"}}
									></i>
								) : (
									<i
										className="fa fa-chevron-down close-reports-list"
										aria-hidden="true"
										style={{display: "inline-grid", fontSize: "14px"}}
									></i>
								)}
						</span>
						</a>
					</li>

					}

					<ul className="report-list">
						{reportListDisplay ?

						<li className="report-item">
							<a
								href={"/reports"}
								onClick={() => {
									localStorage.removeItem("projectId");
								}}
							>
								<i className="fa fa-file-text-o"></i>
								<span className="report-item-text">
												All
											</span>
							</a>
						</li> : null }
						{reportListDisplay
							? projectSubMenu.map((item) => {
								return (
									<li className="report-item">
										<a
											href={"/reports?projectId=" + item.project.id}
											onClick={() => {
												localStorage.removeItem("projectId");
											}}
										>
											<i className="fa fa-file-text-o"></i>
											<span className="report-item-text">
												{item.project.name}
											</span>
										</a>
									</li>
								);
							})
							: null}
					</ul>

					{localStorage.getItem("user") !== null && JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" ?
						props.current === "projects" ?
								<li className="has-subnav current">
									<a href="/projects">
										<i className="fa fa-tasks fa-2x"></i>
										<span className="nav-text">Project</span>
									</a>
								</li>
								:
								<li className="has-subnav">
									<a href="/projects">
										<i className="fa fa-tasks fa-2x"></i>
										<span className="nav-text">Project</span>
									</a>
								</li>
					: null }

					{props.current === "schedule" ?
					<li className="has-subnav current">
						<a href="/schedule">
							<i className="fa fa-calendar fa-2x"></i>
							<span className="nav-text">Scheduled Reports </span>
						</a>
					</li>
					 : <li className="has-subnav">
					 <a href="/schedule">
						 <i className="fa fa-calendar fa-2x"></i>
						 <span className="nav-text">Scheduled Reports </span>
					 </a>
				 </li>}


					{localStorage.getItem("user") !== null && JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" ?
						props.current === "users" ?
							<li className="has-subnav current">
								<a href="/users">
									<i className="fa  fa-user-o fa-2x"></i>
									<span className="nav-text">Users</span>
								</a>
							</li>
							:
							<li className="has-subnav">
								<a href="/users">
									<i className="fa  fa-user-o fa-2x"></i>
									<span className="nav-text">Users</span>
								</a>
							</li>
					 : null }
				</ul>


			{!kLogo ? 
				<ul className="logo logo-k">
					<li>
						<a
							href="/dashboard"
							onClick={() => {
								localStorage.removeItem("projectId");
							}}
						>
							<img
								className="k-logo"
								src={klogo}
								alt="Kafein Logo"
								id="logo"
							/>
						</a>
					</li>
				</ul>
				:
					
				<ul className="logo logo-kafein">
					<li>
						<a
							href="/dashboard"
							onClick={() => {
								localStorage.removeItem("projectId");
							}}
						>
							<img
								className=" kafein-logo"
								src={kafein_logo}
								alt="Kafein Logo"
								id="logo"
							/>
						</a>
					</li>
				</ul>
}
			</nav>
		</div>
	);
};

export default SideNavigation;
